import { render, staticRenderFns } from "./activityFeed.vue?vue&type=template&id=4c47c3d4&scoped=true"
import script from "./activityFeed.vue?vue&type=script&lang=js"
export * from "./activityFeed.vue?vue&type=script&lang=js"
import style0 from "./activityFeed.vue?vue&type=style&index=0&id=4c47c3d4&prod&scoped=true&lang=css"
import style1 from "./activityFeed.vue?vue&type=style&index=1&id=4c47c3d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c47c3d4",
  null
  
)

export default component.exports